// extracted by mini-css-extract-plugin
module.exports = {"flexWrapper":"InlineParagraph-module--flexWrapper--BuTsk","serif":"InlineParagraph-module--serif--CqAMe","sans":"InlineParagraph-module--sans--WO-MR"};